function layout() {
  const ctxView = {
    model: "hotel.housekeeping",
    reportName: "hotel.print_housekeeping.report",
    description: "Ama de Llaves",
    fields: {
      operation_center: {
        type: "many2one",
        model: "company.operation_center",
        required: true,
      },
      employee: {
        type: "many2one",
        model: "company.employee",
      },
      date: {
        type: "date",
        required: true,
      },
      grouped_by_employee: {
        type: "boolean",
        default: true,
      },
      // filter: {
      //   type: "selection",
      //   required: true,
      //   options: OPTIONS,
      // },
      // only_main_guest: {
      //   type: "boolean",
      //   translate: true,
      // },
    },
    list: [],
    form: [
      { name: "operation_center" },
      { name: "employee" },
      { name: "date" },
      { name: "grouped_by_employee" },
      // { name: "operation_center" },
      // { name: "only_main_guest" },
    ],
  };

  return ctxView;
}

export { layout };
